const ServiceCard = ({ service, onServiceSelect }) => {
  return (
    <div
      key={service.title}
      onClick={() => onServiceSelect(service.title)}
      className="flex flex-col items-center gap-3 cursor-pointer hover:scale-105 transition"
    >
      <div className="w-24 h-24 xs:w-32 xs:h-32 md:w-48 md:h-48 rounded-full border-2 border-[var(--service-border)] bg-[var(--service-bg)] hover:bg-[var(--service-hover-bg)] flex items-center justify-center">
        <img
          src={service.icon}
          alt={service.title}
          className="w-16 h-16 xs:w-24 xs:h-24 md:w-32 md:h-32"
        />
      </div>
      <span className="text-[var(--text-pr)] text-sm xs:text-base md:text-lg font-medium">{service.title}</span>
    </div>
  );
};


export default ServiceCard;
